import { Button, ButtonProps, CircularProgress, Tooltip } from "@mui/material";

export default function CustomLoadingButton({
  title,
  isLoading = true,
  Icon = null,
  iconLocation = "endIcon",
  variant = "custom1",
  tooltipTitle = "",
  tooltipPlacement = "top",
  // buttonProps,
  ...rest
}: CustomLoadingButtonProps) {
  const dynamicProp = Icon && {
    [iconLocation]: isLoading ? (
      <CircularProgress size="1rem" color="inherit" />
    ) : (
      Icon && <Icon />
    ),
  };

  const button = (
    <Button variant={variant} {...dynamicProp} {...rest}>
      {!Icon ? (
        isLoading ? (
          <CircularProgress size="1.54rem" color="inherit" />
        ) : (
          title
        )
      ) : (
        title
      )}
    </Button>
  );

  return tooltipTitle ? (
    <Tooltip title={tooltipTitle} placement={tooltipPlacement}>
      <span>{button}</span>
    </Tooltip>
  ) : (
    button
  );
}

interface CustomLoadingButtonProps extends ButtonProps {
  title: string;
  isLoading: boolean;
  Icon?: React.ElementType | null;
  iconLocation?: string;
  tooltipTitle?: string;
  tooltipPlacement?: 'top' | 'bottom' | 'left' | 'right' | 'top-start' | 'top-end' | 'bottom-start' | 'bottom-end' | 'left-start' | 'left-end' | 'right-start' | 'right-end';
}
